/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { RelayParams, RelayParamsInterface } from "../RelayParams";

const _abi = [
  {
    type: "tuple",
    components: [
      {
        type: "address[]",
        name: "tokens",
      },
      {
        type: "address[]",
        name: "providers",
      },
      {
        type: "bytes[]",
        name: "data",
      },
    ],
  },
  {
    type: "tuple",
    components: [
      {
        type: "address[]",
        name: "sendTokens",
      },
      {
        type: "uint256[]",
        name: "sendAmounts",
      },
      {
        type: "address[]",
        name: "externalCallTargets",
      },
      {
        type: "bytes[]",
        name: "externalCallDataList",
      },
      {
        type: "address[]",
        name: "refundTokens",
      },
      {
        type: "address[]",
        name: "refundReceivers",
      },
    ],
  },
  {
    type: "tuple[]",
    components: [
      {
        type: "address",
        name: "owner",
      },
      {
        type: "address",
        name: "spender",
      },
      {
        type: "uint256",
        name: "value",
      },
      {
        type: "uint256",
        name: "deadline",
      },
      {
        type: "uint8",
        name: "v",
      },
      {
        type: "bytes32",
        name: "r",
      },
      {
        type: "bytes32",
        name: "s",
      },
      {
        type: "address",
        name: "token",
      },
    ],
  },
  {
    type: "tuple",
    components: [
      {
        type: "address",
        name: "feeToken",
      },
      {
        type: "uint256",
        name: "feeAmount",
      },
      {
        type: "address[]",
        name: "feeSwapPath",
      },
    ],
  },
  {
    type: "uint256",
  },
  {
    type: "uint256",
  },
] as const;

export class RelayParams__factory {
  static readonly abi = _abi;
  static createInterface(): RelayParamsInterface {
    return new Interface(_abi) as RelayParamsInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): RelayParams {
    return new Contract(address, _abi, runner) as unknown as RelayParams;
  }
}
